import Navbar from "components/navbar/Navbar";
import WithPadding from "components/shared/WithPadding";
import style from "./RefundPolicy.module.scss";
import Footer from "components/footer/Footer";

export default function RefundPolicy() {
  return (
    <div className={style.wrapper}>
      <Navbar background="white" />

      <div className={style.banner}>
        <h1>Cancellation and Refund Policy</h1>
      </div>

      <WithPadding>
        <p>
          At CareerTest.online, we are committed to providing valuable career insights and
          tools that help individuals unlock their potential. Before you proceed with
          any purchases or services on our platform, please review our cancellation and
          refund policy carefully:
        </p>

        <h2>No Refund Policy</h2>
        <p>
          Due to the digital nature of our services, once a purchase has been made and
          access to our tools or reports has been granted, we cannot offer refunds. All
          sales are final, and no refunds will be issued for any tests, reports, or
          other services purchased on CareerTest.online.
        </p>

        <h2>Why No Refunds?</h2>
        <p>
          Our comprehensive reports are generated instantly after you complete your
          assessment, offering immediate value and insights tailored to your unique
          profile. Because of this, we are unable to reverse or reclaim the services
          provided. We encourage users to review all product information and ask any
          questions before making a purchase to ensure that the services meet their
          needs.
        </p>

        <p>
          If you encounter any issues or have further questions about our policy, feel
          free to reach out to our support team at{" "}
          <a href="mailto:hello@careertest.online" className={style.email}>
            hello@careertest.online
          </a>
          , and we will be happy to assist you.
        </p>
      </WithPadding>
         <Footer />
    </div>
  );
}
